export default __webpack_public_path__ + "static/media/arrow-rounded-right-7x11.a178cf7e.svg";